import Median from 'median-js-bridge'

window.Median = Median
